import { render, staticRenderFns } from "./AgreementContent.vue?vue&type=template&id=95ee8712"
import script from "./AgreementContent.vue?vue&type=script&lang=js"
export * from "./AgreementContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports